import {
  EntityLinks,
  Goal,
  Habit,
  HabitSortingMode,
  ID,
  LifeArea,
  lifeAreaOtherID,
  Task,
  WeekDays,
} from '@griply/types';

import { getSortedTasks } from './get-sorted-tasks';
import { GroupedTasks, groupTasksByLifeArea } from './group-tasks-by-life-area';
import { habitSortingModeToSortingMode } from './habit-sorting-mode-to-sorting-mode';
import { isHabitEnded } from './schedules';

export type BuildLifeAreaHabitSectionsOptions = {
  habits: Task[];
  lifeAreas: LifeArea[];
  goals?: Goal[];
  links?: EntityLinks;
  lifeAreaSorting?: ID[] | null;
  habitSortingMode?: HabitSortingMode;
  habitGroupSorting?: Record<string, ID[]> | null;
  today: Date;
  weekStartsOn: WeekDays;
};

export const buildLifeAreaHabitSections = (
  options: BuildLifeAreaHabitSectionsOptions,
): GroupedTasks[] => {
  const {
    habits,
    lifeAreas,
    goals,
    links,
    lifeAreaSorting,
    habitSortingMode,
    habitGroupSorting,
    today,
    weekStartsOn,
  } = options;

  const groups = groupTasksByLifeArea({
    tasks: habits.filter(
      (habit) => !isHabitEnded((habit as Habit).schedules, today),
    ),
    lifeAreas,
    lifeAreaSorting,
    goals,
    links,
  });

  return groups.map<GroupedTasks>((group) => ({
    ...group,
    tasks: getSortedTasks(group.tasks, {
      today,
      weekStartsOn,
      mode: habitSortingMode
        ? [habitSortingModeToSortingMode[habitSortingMode]]
        : undefined,
      order:
        habitGroupSorting?.[
          group.lifeAreaId === lifeAreaOtherID ? 'null' : group.lifeAreaId
        ] ?? [],
    }),
  }));
};
